module.exports = __webpack_public_path__ + "static/hotblack-coffee-about1-8a8f4b51b9eb4c83f4b69c608953035e.png";